export interface ConsultationType {
  id: string;
  title: string;
  subtitle: string;
  duration: string;
  price: number;
  description: string;
  includes: string[];
  icon: string;
  popular?: boolean;
  color: string;
}

export interface BlueprintRitual {
  id: string;
  title: string;
  subtitle: string;
  price: number;
  description: string;
  includes: string[];
  icon: string;
  image: string;
  color: string;
}

export interface ConsultReview {
  id: string;
  name: string;
  location: string;
  consultType: string;
  message: string;
  rating: number;
  avatar: string;
  date: string;
}

export const consultationTypes: ConsultationType[] = [
  {
    id: 'beginner',
    title: 'Beginner Consult',
    subtitle: 'Stap in jouw spirituele reis',
    duration: '30 minuten',
    price: 45,
    description: 'Perfect voor wie net begint met spiritualiteit. We bespreken jouw vragen, energetische toestand en geven je concrete eerste stappen om mee te beginnen.',
    includes: [
      'Energetische check-in',
      'Persoonlijk spiritueel advies',
      'Crystal & product aanbevelingen',
      'Korte meditatie-introductie',
      'Follow-up via e-mail binnen 48 uur',
    ],
    icon: 'ri-seedling-line',
    color: 'from-violet-600/20 to-fuchsia-600/20',
  },
  {
    id: 'scan',
    title: 'Volledige Consult Scan',
    subtitle: 'Een diepgaande energetische scan van je verleden en toekomst',
    duration: '60 minuten',
    price: 145,
    description: 'We maken samen een groeiplan met de gegevens die we doorkrijgen van onze gidsen. Zodat jezelf met de juiste gegevens kan ontwikkelen op spiritueel vlak.',
    includes: [
      'Spiritueel groei',
      '2x follow up',
      'Volledige scan',
      'Persoonlijk groeiplan',
      'Meditatie protocol',
    ],
    icon: 'ri-radar-line',
    popular: true,
    color: 'from-fuchsia-600/20 to-pink-600/20',
  },
];

export const consultReviews: ConsultReview[] = [
  {
    id: 'cr1',
    name: 'Priya M.',
    location: 'Amsterdam',
    consultType: 'Volledige Consult Scan',
    message: 'Dit consult heeft mijn leven letterlijk veranderd. Ze zag dingen uit mijn verleden die niemand kende en gaf me een groeiplan dat ik elke week gebruik. De 2 follow-ups waren ook heel waardevol. Ik ben zo blij dat ik dit heb gedaan.',
    rating: 5,
    avatar: 'https://public.readdy.ai/ai/img_res/70883bde7985a1adbac570db96f913e9.jpg',
    date: 'Februari 2025',
  },
  {
    id: 'cr2',
    name: 'Naomi S.',
    location: 'Rotterdam',
    consultType: 'Volledige Consult Scan',
    message: 'Ik had al eerder consulten gedaan maar dit was anders. Het voelde diep en echt. Het meditatie protocol dat ik meekreeg doe ik nu elke ochtend. Na 3 weken merk ik al een enorm verschil in hoe ik mezelf voel en hoe ik reageer op situaties.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=surinamese%20dutch%20woman%20young%20professional%20calm%20peaceful%20portrait%20warm%20studio%20light%20confident%20natural%20hair&width=100&height=100&seq=cr2&orientation=squarish',
    date: 'Januari 2025',
  },
  {
    id: 'cr3',
    name: 'Roshani B.',
    location: 'Den Haag',
    consultType: 'Volledige Consult Scan',
    message: 'Ik stond op een kruispunt in mijn leven en wist niet welke kant ik op moest. Na de scan was alles helderder. Het persoonlijk groeiplan is zo goed op mij afgestemd, alsof ze precies wist wat ik nodig had. Heel erg bedankt!',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=young%20hindustani%20woman%20thoughtful%20serene%20smile%20portrait%20natural%20light%20studio%20beautiful%20diverse%20woman%20warm%20glow&width=100&height=100&seq=cr3&orientation=squarish',
    date: 'Maart 2025',
  },
  {
    id: 'cr4',
    name: 'Lisette A.',
    location: 'Utrecht',
    consultType: 'Beginner Consult',
    message: 'Als complete beginner wist ik niet wat ik kon verwachten. Het was zo toegankelijk en warm. Geen ingewikkelde termen, gewoon duidelijke uitleg en concrete stappen om mee te beginnen. Perfect voor wie net begint met spiritualiteit.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=dutch%20woman%20thirties%20warm%20approachable%20smile%20portrait%20soft%20natural%20light%20studio%20beautiful%20open%20expression&width=100&height=100&seq=cr4&orientation=squarish',
    date: 'December 2024',
  },
  {
    id: 'cr5',
    name: 'Devika P.',
    location: 'Almere',
    consultType: 'Volledige Consult Scan',
    message: 'Ze ontving informatie over situaties in mijn toekomst die op dat moment onmogelijk te weten waren. Twee maanden later klopte het exact. Dit is geen gewone consultatie, dit is echte verbinding met hogere gidsen. Ik ben diep onder de indruk.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=indian%20surinamese%20woman%20mature%20elegant%20warm%20eyes%20portrait%20studio%20light%20peaceful%20spiritual%20woman%20beautiful&width=100&height=100&seq=cr5&orientation=squarish',
    date: 'Februari 2025',
  },
  {
    id: 'cr6',
    name: 'Shanty V.',
    location: 'Breda',
    consultType: 'Beginner Consult',
    message: 'Ik twijfelde lang of ik het zou doen maar ik ben zo blij dat ik de stap heb gezet. In 30 minuten meer duidelijkheid gekregen dan in jaren van zoeken. Het advies was heel persoonlijk en de productaanbevelingen passen precies bij mijn situatie.',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=young%20surinamese%20woman%20happy%20bright%20smile%20portrait%20warm%20natural%20light%20beautiful%20confident%20youthful%20vibrant&width=100&height=100&seq=cr6&orientation=squarish',
    date: 'Januari 2025',
  },
];

export const blueprintRituals: BlueprintRitual[] = [
  {
    id: 'ee-reinigingsbad',
    title: 'Evil Energy Destroy Reinigingsbad Blueprint',
    subtitle: 'Complete reinigingsgids',
    price: 14.95,
    description: 'Stap-voor-stap digitale gids voor het correct gebruiken van Evil Energy Destroy voor ruimte- en energiereiniging. Leer hoe je een krachtig beschermend bad ritueel uitvoert.',
    includes: [
      'Digitale PDF gids',
      'Stap-voor-stap ritueel protocol',
      'Beste tijdstippen & maan-fasen gids',
      'Affirmaties & intenties bij het ritueel',
    ],
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=dark%20atmospheric%20spiritual%20cleansing%20bath%20ritual%20with%20asafoetida%20hing%20herbs%20warm%20golden%20candlelight%20dark%20stone%20surface%20aromatic%20soap%20and%20herbs%20dramatic%20cinematic%20still%20life%20photography%20mystical%20protection%20ceremony%20dark%20moody&width=600&height=400&seq=ee-bad-blueprint&orientation=landscape',
    color: 'from-amber-600/20 to-fuchsia-600/20',
  },
  {
    id: 'ee-baby-hing',
    title: 'Evil Energy Destroy Baby Hing Pasta Blueprint',
    subtitle: 'Complete reinigingsgids',
    price: 14.95,
    description: 'Stap-voor-stap digitale gids voor het correct gebruiken van Evil Energy Destroy Baby Hing Pasta voor ruimte- en energiereiniging van baby en omgeving.',
    includes: [
      'Digitale PDF gids',
      'Stap-voor-stap ritueel protocol',
      'Beste tijdstippen & energiengids',
      'Affirmaties & intenties bij het ritueel',
    ],
    icon: 'ri-heart-3-line',
    image: 'https://readdy.ai/api/search-image?query=gentle%20sacred%20spiritual%20baby%20protection%20ritual%20hing%20asafoetida%20paste%20small%20ceramic%20bowl%20soft%20warm%20candlelight%20delicate%20dried%20herbs%20dark%20wood%20surface%20dark%20moody%20cinematic%20photography%20newborn%20protection%20ceremony%20intimate%20close-up&width=600&height=400&seq=ee-baby-blueprint&orientation=landscape',
    color: 'from-rose-600/20 to-amber-600/20',
  },
  {
    id: 'ee-hing-poeder',
    title: 'Reinigingsrook Evil Energy Destroy Hing Poeder Blueprint',
    subtitle: 'Professioneel rookritueel',
    price: 14.95,
    description: 'Professionele handleiding voor reinigingsrook rituelen met Evil Energy Destroy Hing Poeder. Ontdek hoe je krachtige rookrituelen uitvoert voor jezelf, je huis en anderen.',
    includes: [
      'Digitale PDF gids',
      'Gids voor rookkruiden & harsen',
      'Rookritueel voor huis, kantoor & persoon',
      'Combinaties voor specifieke intenties',
    ],
    icon: 'ri-fire-line',
    image: 'https://readdy.ai/api/search-image?query=asafoetida%20hing%20powder%20burning%20incense%20smoke%20ritual%20dark%20atmospheric%20mystical%20photography%20golden%20smoke%20tendrils%20rising%20from%20brass%20bowl%20dark%20stone%20surface%20dramatic%20cinematic%20spiritual%20protection%20ceremony%20moody%20warm%20tones%20close-up&width=600&height=400&seq=ee-rook-blueprint&orientation=landscape',
    color: 'from-orange-600/20 to-fuchsia-600/20',
  },
];
